import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { Row } from '../types';
import { useQueryContext } from '../../../../shared';
import { useOrderingContext } from '../../../hooks';
import { HeadCell } from '../../../../../ui-kit/Table/types';
import { TableCell, TableHeadSearchField, TableHeadSortToggle, Typography } from '../../../../../ui-kit';

interface ProductStatisticsCellProps {
    index: number;
    headCell: HeadCell<Row>;
}


const ProductStatisticsHeadCell = ({ index, headCell }: ProductStatisticsCellProps) => {
    const { t } = useTranslation();
    const { query, setQuery } = useQueryContext();
    const orderingContext = useOrderingContext();

    let cellContent: React.ReactNode;

    switch (headCell.id) {
        case 'productName':
            cellContent = (
                <TableHeadSearchField
                    margin='dense'
                    value={query}
                    onChange={setQuery}
                    placeholder={t('Name')}
                />
            );
            break;
        case 'quantity':
        case 'markup':
        case 'foodCost':
        case 'revenue': {
            const currentOrdering = orderingContext[headCell.id];
            const handleOrdering = (nextOrdering: string | false) => {
                return orderingContext.setOrderingContext({ [headCell.id]: nextOrdering });

            };

            cellContent = (
                <Box display='flex' justifyContent={headCell.align} alignItems='center'>
                    <TableHeadSortToggle sort={currentOrdering} setSort={handleOrdering} />
                    <Box mr={0.5} />
                    <Typography
                        uppercase
                        color='textSecondary'
                        variant='caption'
                    >
                        {t(...headCell.label)}
                    </Typography>
                </Box>
            );
            break;
        }
        default:
            cellContent = (
                <Typography
                    uppercase
                    color='textSecondary'
                    variant='caption'
                >
                    {t(...headCell.label)}
                </Typography>
            );
    }

    return (
        <TableCell
            id={headCell.id as string}
            key={headCell.id as string}
            align={headCell.align}
            isTableHead
            isSticky={index === 0}
            padding='none'
        >
            <Box mx={2}>
                {cellContent}
            </Box>
        </TableCell>
    );
};

export default ProductStatisticsHeadCell;
